import cookieHelper from "@irati/utils/cookies"

export default function getCookie(COOKIE_NAME: string) {
  try {
    const version = cookieHelper.getItem(COOKIE_NAME) || ""
    return version
  } catch (e) {
    return ""
  }
}
